import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'createAttribute',
    serviceName: 'admin',
    query: gql`
      mutation createAttribute($title: String!, $type: String, $details: String, $category_id: String) {
        createAttribute(title: $title, type: $type, details: $details, category_id: $category_id) {
          messages
        }
      }
    `,
  },
};

export default schema;
